import React from "react";
import { LeadCard, ReasonAndTime } from "./parts";
import { parkedView, conversationView, opening } from "./leadModel.mjs";
import { shortDate } from "../format.mjs";

/*
 * PARKED (1,143 of 1,403 companies): why and since when, when it wakes, what
 * happened last time when it is recorded, the last message each way, the score
 * (frame 1g, Fieldline on its wake-up day). The conversation sits inside this block
 * (the matrix: "Inside the lead block"); money and audit are absent.
 *
 *   - "Stopped chasing · since Apr 1" and "Removed from the pipeline by you, remind
 *     in 6 months. Wakes today, Oct 1.": the park's reason in words (the import's
 *     "never engaged" included), who parked it, and the wake-up; a park whose reason
 *     is a loss's says it is a former loss; no wake-up date says so;
 *   - the stay ("first stay · got as far as Pricing sent") and the last stay before
 *     it come from pipeline_stints, which exist from Feb 2026 only; with none,
 *     nothing is said rather than "first stay";
 *   - "Last from them · Marco, Mar 3" in full and "Last from us · you, Mar 24" by its
 *     first line (ours is the chase; theirs is what the re-engage answers), each at
 *     reading size with "snippet only" on mail kept as a snippet, then Open in Gmail;
 *   - "Score 48 · high. Fits on … Breakdown" and their time now.
 *
 * Props:
 *   record   the shell's bundle: company (status_reason, recycle_until,
 *            status_history, pipeline_stints), timeline.rows, score, zones, contact
 *   ops      ops.toggleBreakdown
 */
export default function Parked({ record, ops }) {
  const v = parkedView(record.company, { now: record.now });
  const rows = record.timeline.rows;
  const ctx = { company: record.company, contact: record.contact, zones: record.zones, now: record.now };
  const them = conversationView(rows.filter((r) => (r.direction || (r.metadata || {}).direction) === "inbound"), ctx);
  const us = conversationView(rows.filter((r) => (r.direction || (r.metadata || {}).direction) === "outbound"), ctx);
  const url = (them && them.thread.url) || (us && us.thread.url) || null;
  const d = (ts) => shortDate(ts, { now: record.now });

  return (
    <LeadCard label="Parked" meta={v.stay}>
      <div>
        <div className="rec-headline">{v.headline}</div>
        <div className="rec-body">{v.sub}</div>
        {v.lastTime && <div className="rec-body">{v.lastTime}.</div>}
      </div>
      {(them || us) && (
        <div className="rec-lead__sec rec-lead__sec--10">
          {them && (
            <div>
              <div className="rec-lead__small">
                Last from them · {them.lead.short}, {d(them.lead.at)}
                {them.lead.snippet ? " · snippet only" : ""}
              </div>
              <div className="rec-quote rec-quote--md">{them.lead.body}</div>
            </div>
          )}
          {us && (
            <div>
              <div className="rec-lead__small">
                Last from us · you, {d(us.lead.at)}
                {us.lead.snippet ? " · snippet only" : ""}
              </div>
              <div className="rec-quote rec-quote--md rec-lead__muted">{opening(us.lead.row.body, 140)}</div>
            </div>
          )}
          {url && (
            <a className="rec-lead__gmail" href={url} target="_blank" rel="noopener noreferrer">
              Open in Gmail ↗
            </a>
          )}
        </div>
      )}
      <ReasonAndTime record={record} ops={ops} mode="fits" />
    </LeadCard>
  );
}
